import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnDestroy,
  OnInit
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef
} from '@angular/material/dialog';
import { SafeHtml } from '@angular/platform-browser';
import { Store } from '@ngxs/store';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { HelpTopicState } from '../../state';
import { LoadOne } from '../../state/help-topic.actions';
import { HelpTopic } from '../../state/help-topic.model';


@Component({
    selector: 'odq-help-topic-viewer-dialog',
    templateUrl: './help-topic-viewer-dialog.component.html',
    styleUrls: ['./help-topic-viewer-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HelpTopicViewerDialogComponent implements OnInit, OnDestroy {
  private destroy$? = new Subject<void>();

  isLoading$ = this.store.select<boolean>(HelpTopicState.isLoading);
  helpTopic$ = this.store.select<HelpTopic>(HelpTopicState.helpTopic);
  helpTopic = new HelpTopic();
  
  constructor(
    private dialogRef: MatDialogRef<HelpTopicViewerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private store: Store
  ) {
    this.store.dispatch(new LoadOne(data.domain, data.key));
  }

  ngOnInit(): void {
    this.helpTopic$
      .pipe(
        filter((value) => value !== undefined),
        takeUntil(this.destroy$)
      )
      .subscribe((x) => {
        this.helpTopic = x;
      });
  }

  /**
   * Replaces certain HTML tag combinations to help with presentation
   * @param htmlText 
   * @returns 
   */
  formatHelpTopicHtml(htmlText: string): SafeHtml  {
    htmlText = htmlText.replace(/<p><br><\/p>/gi, '<br>');
    return htmlText = htmlText.replace(/<p>/gi, '<br\/>').replace(/<\/p>/gi, '');
  }

  cancel() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
